import React from 'react';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { QueueMeasurementRead } from '@ragu-components/ord-types';

const QueueMeasurementsList = React.lazy(async () => import('./QueueMeasurementsList'));

export const queueMeasurementsResource: OrdResourceProps = {
  key: `queue_measurements`,
  name: `queue_measurements`,
  list: <QueueMeasurementsList />,
  options: {},
  recordRepresentation: (record: QueueMeasurementRead): string => `${record.name}`,
};
